// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ensure this wrapper component doesn't break Ionic grid (ion-row > ion-col) */
:host {
  /* Flattens the host so <ion-col> is treated as a direct child of ion-row */
  display: contents;
}

.longtext ion-label {
  padding-top: 4px;
}

.full-width-p {
  width: 100%;
}

.disabled p {
  opacity: 0.5;
}

ion-item-divider.edit {
  background: var(--mc-surface-0);
  border-bottom: none;
}

ion-item.edit > ion-label.readonly {
  opacity: 0.3;
}
ion-item.edit ion-input,
ion-item.edit ion-textarea,
ion-item.edit ion-select {
  font-size: 15px;
  color: var(--ion-color-secondary);
}
ion-item.edit ion-input.readonly,
ion-item.edit ion-textarea.readonly,
ion-item.edit ion-select.readonly {
  opacity: 0.3;
}
ion-item.edit ion-select {
  padding-bottom: 8px;
}
ion-item.edit.datetime, ion-item.edit.date, ion-item.edit.time {
  --background-hover-opacity: 0;
}
ion-item.edit.price ion-input {
  cursor: pointer !important;
}
ion-item.edit ion-datetime {
  background: var(--ion-color-lighter-lightest);
  padding-top: 10px;
  padding-bottom: 0px;
  margin-top: 10px;
  margin-bottom: 20px;
}
ion-item.edit ion-datetime {
  font-size: 15px;
  color: var(--ion-color-secondary);
}
ion-item.edit ion-item.segment {
  padding-top: 0;
  margin-top: 0;
  margin-left: 16px;
  margin-bottom: 16px;
}
ion-item.edit.segment:has(.isMobile), ion-item.edit.segmented:has(.isMobile) {
  --padding-start: 0;
}
ion-item.edit.segment:has(.isMobile) ion-item.edit ion-segment, ion-item.edit.segmented:has(.isMobile) ion-item.edit ion-segment {
  margin-left: 0;
}
ion-item.edit.segment:not(.isMobile) ion-item.edit ion-segment, ion-item.edit.segmented:not(.isMobile) ion-item.edit ion-segment {
  margin-left: 16px;
}
ion-item.edit ion-segment {
  display: flex;
}
ion-item.edit ion-segment ion-segment-button {
  flex: 1 1 0;
}
ion-item.edit ion-segment ion-segment-button ion-label {
  text-transform: initial;
  font-size: 12px;
  color: var(--ion-color-medium);
}
ion-item.edit ion-segment ion-segment-button.segment-button-checked {
  --ion-background-color-step-350: var(--ion-color-primary);
}
ion-item.edit ion-segment ion-segment-button.segment-button-checked.disabledSegment {
  --ion-background-color-step-350: var(--mc-color-mid-grey);
}
ion-item.edit ion-segment ion-segment-button.segment-button-checked.disabledSegment ion-label {
  font-size: 12px;
  color: var(--mc-color-black);
}
ion-item.edit ion-segment ion-segment-button.segment-button-checked ion-label {
  font-size: 12px;
  color: var(--ion-color-primary-contrast);
}
ion-item.edit .mc-note.error-icon {
  display: none;
}
ion-item.edit.mc-invalid .mc-note.error-icon {
  top: 20px;
  right: 5px;
}
ion-item.edit.mc-invalid.lookup .mc-note.error-icon, ion-item.edit.mc-invalid.lookups .mc-note.error-icon, ion-item.edit.mc-invalid.select .mc-note.error-icon, ion-item.edit.mc-invalid.selects .mc-note.error-icon, ion-item.edit.mc-invalid.vehicle .mc-note.error-icon, ion-item.edit.mc-invalid.contact .mc-note.error-icon, ion-item.edit.mc-invalid.wholesale-contact .mc-note.error-icon, ion-item.edit.mc-invalid.company .mc-note.error-icon, ion-item.edit.mc-invalid.photo .mc-note.error-icon {
  top: 14px;
  right: 5px;
}
ion-item.edit.mc-invalid.toggle .mc-note.error-icon {
  top: 15px;
}
ion-item.edit.mc-invalid.signature .mc-note.error-icon {
  top: 2px;
}
ion-item.edit.mc-invalid.photo .mc-note.error-icon {
  top: 16px;
}
ion-item.edit.mc-invalid.item-has-value .mc-note.error-icon {
  top: 16px;
}
ion-item.edit.toggle ion-toggle {
  --track-background-checked: var(--ion-color-lighter-light);
}
ion-item.edit.toggle ion-toggle::part(native) {
  --track-background-checked: var(--ion-color-lighter-light);
}
ion-item.edit .ion-color.toggle-checked .toggle-inner {
  background: var(--ion-color-primary);
}
ion-item.edit app-select-list,
ion-item.edit app-select-list-lazy,
ion-item.edit app-select-list-multi,
ion-item.edit app-select-contact,
ion-item.edit app-select-vehicle {
  width: 100%;
}
ion-item.edit app-select-list,
ion-item.edit app-select-list-lazy,
ion-item.edit app-select-list-multi,
ion-item.edit app-select-list-lazy-multi {
  width: 100%;
  margin-bottom: 12px;
  margin-top: 12px;
  min-height: 18px;
}
ion-item.edit.lookup.item-label-stacked {
  --min-height: 56px;
}
ion-item.edit.lookup {
  --border-width: 0 0 1px 0;
}

ion-item ion-avatar {
  display: none;
}

ion-item.field-has-value:not(.edit).email.hasValue:hover, ion-item.field-has-value:not(.edit).url.hasValue:hover, ion-item.field-has-value:not(.edit).link.hasValue:hover, ion-item.field-has-value:not(.edit).path.hasValue:hover, ion-item.field-has-value:not(.edit).contact.hasValue:hover, ion-item.field-has-value:not(.edit).vehicle.hasValue:hover, ion-item.field-has-value:not(.edit).phone.hasValue:hover, ion-item.field-has-value:not(.edit).tel.hasValue:hover, ion-item.field-has-value:not(.edit).address.hasValue:hover {
  cursor: pointer;
}
ion-item.field-has-value:not(.edit).email.hasValue:hover p span.text, ion-item.field-has-value:not(.edit).url.hasValue:hover p span.text, ion-item.field-has-value:not(.edit).link.hasValue:hover p span.text, ion-item.field-has-value:not(.edit).path.hasValue:hover p span.text, ion-item.field-has-value:not(.edit).contact.hasValue:hover p span.text, ion-item.field-has-value:not(.edit).vehicle.hasValue:hover p span.text, ion-item.field-has-value:not(.edit).phone.hasValue:hover p span.text, ion-item.field-has-value:not(.edit).tel.hasValue:hover p span.text, ion-item.field-has-value:not(.edit).address.hasValue:hover p span.text {
  opacity: 0.8;
}
ion-item.field-has-value:not(.edit).email, ion-item.field-has-value:not(.edit).url, ion-item.field-has-value:not(.edit).link, ion-item.field-has-value:not(.edit).path, ion-item.field-has-value:not(.edit).contact, ion-item.field-has-value:not(.edit).vehicle, ion-item.field-has-value:not(.edit).phone, ion-item.field-has-value:not(.edit).tel, ion-item.field-has-value:not(.edit).address {
  text-decoration: none;
}
ion-item.field-has-value:not(.edit).email.hasValue:hover p span.text, ion-item.field-has-value:not(.edit).url.hasValue:hover p span.text, ion-item.field-has-value:not(.edit).link.hasValue:hover p span.text, ion-item.field-has-value:not(.edit).path.hasValue:hover p span.text, ion-item.field-has-value:not(.edit).phone.hasValue:hover p span.text, ion-item.field-has-value:not(.edit).tel.hasValue:hover p span.text {
  color: var(--ion-color-medium);
}
ion-item.field-has-value:not(.edit) ion-avatar {
  display: inline;
  border-radius: 100%;
  text-align: center;
  width: 20px;
  height: 20px;
  background: var(--ion-color-light-shade);
  margin-right: 20px;
  margin-top: -12px;
}
ion-item.field-has-value:not(.edit) ion-avatar span {
  font-size: 12px;
  line-height: 20px;
  top: 0;
  color: var(--ion-color-secondary);
}
ion-item.field-has-value:not(.edit) ion-thumbnail.r2023 {
  margin-right: 20px;
}

.image-placeholder {
  border: 1px solid var(--ion-color-lighter-contrast);
  margin-top: 8px;
  width: 100%;
  text-align: center;
}
.image-placeholder .icon-photo:before {
  color: var(--ion-color-lighter-light);
  content: "\\e410";
  font-family: "icomoon" !important;
  font-size: 80px;
  line-height: 160px;
}

ion-item.readonly .image-placeholder {
  margin-top: 0px;
}

app-image-input {
  width: 100%;
}

app-image-displayer {
  margin-top: 8px;
  border: 1px solid var(--mc-divider);
}

.signature-pad-edit,
.signature-pad-view {
  min-height: 200px;
  position: relative;
  margin: 8px auto;
}

.signature-pad-view {
  border: 1px solid var(--mc-divider);
}

.signature-pad-clear:before {
  content: "\\e5cd";
  color: var(--ion-color-lighter-light);
  font-family: "icomoon" !important;
  font-size: 18px;
  line-height: 14px;
  margin: 0 auto;
  margin-left: -1px;
}
.signature-pad-clear {
  background: var(--mc-overlay-50);
  text-align: center;
  position: absolute;
  right: 15px;
  top: 50px;
  padding: 8px;
  border-radius: 50%;
  width: 32px;
  height: 32px;
}

.signature-pad-modify:before {
  content: "\\e254";
  color: var(--ion-color-lighter-light);
  font-family: "icomoon" !important;
  font-size: 18px;
  line-height: 14px;
  margin: 0 auto;
  margin-left: -1px;
}
.signature-pad-modify {
  background: var(--mc-overlay-50);
  text-align: center;
  position: absolute;
  right: 10px;
  top: 15px;
  padding: 8px;
  border-radius: 50%;
  width: 32px;
  height: 32px;
}

.vehicle ion-thumbnail img {
  border-radius: 5px;
}

:host .datetime-calendar,
:host .datetime-year {
  border: 1px sold var(--ion-color-lighter-light);
}

.icon-padding {
  padding-right: 5px;
}

.no-pointer {
  cursor: default !important;
}

.view-button {
  text-transform: none;
  --border-radius: 5px;
  --background: var(--mc-color-light-grey);
  --color: var(--mc-color-dark-grey);
  --color-activated: var(--ion-color-medium);
  font-weight: 400;
  font-size: 14px;
  --box-shadow: none;
  letter-spacing: 0;
  margin-left: 0px;
  height: 36px;
}

app-signature {
  cursor: pointer;
}

.price-editor {
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
}

.price-editor-button {
  --color: var(--ion-color-secondary);
  --background: transparent;
  --border: none;
  --box-shadow: none;
  --hover-background: transparent;
  --hover-border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding-left: 5px;
  padding-right: 0px !important;
}

.settings-icon {
  padding-bottom: 2px;
  font-size: 20px;
}

.non-editable-label {
  color: var(--ion-color-medium);
  cursor: pointer;
  font-size: 12px;
  align-self: center;
}

.rich-text-editor {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/field/field.component.scss"],"names":[],"mappings":"AAAA,+EAAA;AACA;EACC,2EAAA;EACA,iBAAA;AACD;;AAGI;EACI,gBAAA;AAAR;;AAIA;EACI,WAAA;AADJ;;AAIA;EACI,YAAA;AADJ;;AAIA;EACI,+BAAA;EACA,mBAAA;AADJ;;AAaQ;EACI,YAAA;AAVZ;AAcI;;;EAKI,eAAA;EACA,iCAAA;AAdR;AAgBQ;;;EACI,YAAA;AAZZ;AAgBI;EACI,mBAAA;AAdR;AAiBI;EAGI,6BAAA;AAjBR;AAqBQ;EACI,0BAAA;AAnBZ;AAyBI;EACI,6CAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAvBR;AA0BI;EAGI,eAAA;EACA,iCAAA;AA1BR;AA6BI;EACI,cAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;AA3BR;AA+BI;EAEI,kBAAA;AA9BR;AA+BQ;EAEI,cAAA;AA9BZ;AAoCQ;EAEI,iBAAA;AAnCZ;AAuCI;EACI,aAAA;AArCR;AAuCQ;EACI,WAAA;AArCZ;AAuCY;EACI,uBAAA;EACA,eAAA;EACA,8BAAA;AArChB;AAwCY;EACI,yDAAA;AAtChB;AAwCgB;EACI,yDAAA;AAtCpB;AAwCoB;EACI,eAAA;EACA,4BAAA;AAtCxB;AA0CgB;EACI,eAAA;EACA,wCAAA;AAxCpB;AA8CI;EACI,aAAA;AA5CR;AAgDQ;EACI,SAAA;EACA,UAAA;AA9CZ;AAiDQ;EASI,SAAA;EACA,UAAA;AAvDZ;AA0DQ;EACI,SAAA;AAxDZ;AA2DQ;EACI,QAAA;AAzDZ;AA4DQ;EACI,SAAA;AA1DZ;AA6DQ;EACI,SAAA;AA3DZ;AA+DI;EACI,0DAAA;AA7DR;AAgEI;EACI,0DAAA;AA9DR;AAiEI;EACI,oCAAA;AA/DR;AAkEI;;;;;EAKI,WAAA;AAhER;AAmEI;;;;EAII,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AAjER;AAoEI;EACI,kBAAA;AAlER;AAqEI;EACI,yBAAA;AAnER;;AAuEA;EACI,aAAA;AApEJ;;AAoFQ;EACI,eAAA;AAjFZ;AAmFY;EAEI,YAAA;AAlFhB;AAkEI;EAoBI,qBAAA;AAnFR;AA4FQ;EAEI,8BAAA;AA3FZ;AA+FI;EACI,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,wCAAA;EACA,kBAAA;EACA,iBAAA;AA7FR;AA+FQ;EACI,eAAA;EACA,iBAAA;EACA,MAAA;EACA,iCAAA;AA7FZ;AAiGI;EACI,kBAAA;AA/FR;;AAmGA;EACI,mDAAA;EAEA,eAAA;EACA,WAAA;EACA,kBAAA;AAjGJ;AAmGI;EACI,qCAAA;EACA,gBAAA;EACA,iCAAA;EACA,eAAA;EACA,kBAAA;AAjGR;;AAqGA;EACI,eAAA;AAlGJ;;AAqGA;EACI,WAAA;AAlGJ;;AAqGA;EACI,eAAA;EACA,mCAAA;AAlGJ;;AAqGA;;EAEI,iBAAA;EACA,kBAAA;EACA,gBAAA;AAlGJ;;AAqGA;EACI,mCAAA;AAlGJ;;AAsGI;EACI,gBAAA;EACA,qCAAA;EACA,iCAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AAnGR;AA2FA;EAWI,gCAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAnGJ;;AAuGI;EACI,gBAAA;EACA,qCAAA;EACA,iCAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AApGR;AA4FA;EAWI,gCAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AApGJ;;AAuGA;EACI,kBAAA;AApGJ;;AAuGA;;EAEI,+CAAA;AApGJ;;AAuGA;EACI,kBAAA;AApGJ;;AAuGA;EACI,0BAAA;AApGJ;;AAuGA;EACI,oBAAA;EACA,oBAAA;EACA,wCAAA;EACA,kCAAA;EACA,0CAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AApGJ;;AAwGA;EACI,eAAA;AArGJ;;AAwGA;EACI,aAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;AArGJ;;AAyGA;EACI,mCAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,+BAAA;EACA,oBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,6BAAA;AAtGJ;;AAyGA;EACI,mBAAA;EACA,eAAA;AAtGJ;;AAyGA;EACI,8BAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AAtGJ;;AAyGA;EACI,WAAA;AAtGJ","sourcesContent":["/* Ensure this wrapper component doesn't break Ionic grid (ion-row > ion-col) */\r\n:host {\r\n\t/* Flattens the host so <ion-col> is treated as a direct child of ion-row */\r\n\tdisplay: contents;\r\n}\r\n\r\n.longtext {\r\n    ion-label {\r\n        padding-top: 4px;\r\n    }\r\n}\r\n\r\n.full-width-p {\r\n    width: 100%;\r\n}\r\n\r\n.disabled p {\r\n    opacity: 0.5;\r\n}\r\n\r\nion-item-divider.edit {\r\n    background: var(--mc-surface-0);\r\n    border-bottom: none;\r\n}\r\n\r\n// ion-note.notdirty.error-icon {\r\n// \topacity: 0.2;\r\n// \tion-icon {\r\n// \t\tcolor: black;\r\n// \t\t--ion-color-base: black !important;\r\n// \t}\r\n// }\r\nion-item.edit {\r\n    >ion-label {\r\n        &.readonly {\r\n            opacity: 0.3;\r\n        }\r\n    }\r\n\r\n    ion-input,\r\n    ion-textarea,\r\n    ion-select {\r\n        // --padding-top: 0;\r\n        // --padding-bottom: 0px;\r\n        font-size: 15px;\r\n        color: var(--ion-color-secondary);\r\n\r\n        &.readonly {\r\n            opacity: 0.3;\r\n        }\r\n    }\r\n\r\n    ion-select {\r\n        padding-bottom: 8px;\r\n    }\r\n\r\n    &.datetime,\r\n    &.date,\r\n    &.time {\r\n        --background-hover-opacity: 0;\r\n    }\r\n\r\n    &.price {\r\n        ion-input {\r\n            cursor: pointer !important;\r\n        }\r\n    }\r\n\r\n    ;\r\n\r\n    ion-datetime {\r\n        background: var(--ion-color-lighter-lightest);\r\n        padding-top: 10px;\r\n        padding-bottom: 0px;\r\n        margin-top: 10px;\r\n        margin-bottom: 20px;\r\n    }\r\n\r\n    ion-datetime {\r\n        // --padding-top: 0;\r\n        // --padding-start: 0;\r\n        font-size: 15px;\r\n        color: var(--ion-color-secondary);\r\n    }\r\n\r\n    ion-item.segment {\r\n        padding-top: 0;\r\n        margin-top: 0;\r\n        margin-left: 16px;\r\n        margin-bottom: 16px;\r\n    }\r\n\r\n\r\n    &.segment:has(.isMobile),\r\n    &.segmented:has(.isMobile) {\r\n        --padding-start: 0;\r\n        ion-item.edit ion-segment\r\n        {\r\n            margin-left: 0;\r\n        }\r\n    }\r\n    &.segment:not(.isMobile),\r\n    &.segmented:not(.isMobile)\r\n    {\r\n        ion-item.edit ion-segment\r\n        {\r\n            margin-left: 16px;\r\n        }\r\n    }\r\n\r\n    ion-segment {\r\n        display: flex;\r\n\r\n        ion-segment-button {\r\n            flex: 1 1 0;\r\n\r\n            ion-label {\r\n                text-transform: initial;\r\n                font-size: 12px;\r\n                color: var(--ion-color-medium);\r\n            }\r\n\r\n            &.segment-button-checked {\r\n                --ion-background-color-step-350: var(--ion-color-primary);\r\n\r\n                &.disabledSegment {\r\n                    --ion-background-color-step-350: var(--mc-color-mid-grey);\r\n\r\n                    ion-label {\r\n                        font-size: 12px;\r\n                        color: var(--mc-color-black);\r\n                    }\r\n                }\r\n\r\n                ion-label {\r\n                    font-size: 12px;\r\n                    color: var(--ion-color-primary-contrast);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .mc-note.error-icon {\r\n        display: none;\r\n    }\r\n\r\n    &.mc-invalid {\r\n        .mc-note.error-icon {\r\n            top: 20px;\r\n            right: 5px;\r\n        }\r\n\r\n        &.lookup .mc-note.error-icon,\r\n        &.lookups .mc-note.error-icon,\r\n        &.select .mc-note.error-icon,\r\n        &.selects .mc-note.error-icon,\r\n        &.vehicle .mc-note.error-icon,\r\n        &.contact .mc-note.error-icon,\r\n        &.wholesale-contact .mc-note.error-icon,\r\n        &.company .mc-note.error-icon,\r\n        &.photo .mc-note.error-icon {\r\n            top: 14px;\r\n            right: 5px;\r\n        }\r\n\r\n        &.toggle .mc-note.error-icon {\r\n            top: 15px;\r\n        }\r\n\r\n        &.signature .mc-note.error-icon {\r\n            top: 2px;\r\n        }\r\n\r\n        &.photo .mc-note.error-icon {\r\n            top: 16px;\r\n        }\r\n\r\n        &.item-has-value .mc-note.error-icon {\r\n            top: 16px;\r\n        }\r\n    }\r\n\r\n    &.toggle ion-toggle {\r\n        --track-background-checked: var(--ion-color-lighter-light);\r\n    }\r\n\r\n    &.toggle ion-toggle::part(native) {\r\n        --track-background-checked: var(--ion-color-lighter-light);\r\n    }\r\n\r\n    .ion-color.toggle-checked .toggle-inner {\r\n        background: var(--ion-color-primary);\r\n    }\r\n\r\n    app-select-list,\r\n    app-select-list-lazy,\r\n    app-select-list-multi,\r\n    app-select-contact,\r\n    app-select-vehicle {\r\n        width: 100%;\r\n    }\r\n\r\n    app-select-list,\r\n    app-select-list-lazy,\r\n    app-select-list-multi,\r\n    app-select-list-lazy-multi {\r\n        width: 100%;\r\n        margin-bottom: 12px;\r\n        margin-top: 12px;\r\n        min-height: 18px;\r\n    }\r\n\r\n    &.lookup.item-label-stacked {\r\n        --min-height: 56px;\r\n    }\r\n\r\n    &.lookup {\r\n        --border-width: 0 0 1px 0;\r\n    }\r\n}\r\n\r\nion-item ion-avatar {\r\n    display: none;\r\n}\r\n\r\nion-item.field-has-value:not(.edit) {\r\n\r\n    &.email,\r\n    &.url,\r\n    &.link,\r\n    &.path,\r\n    &.contact,\r\n    &.vehicle,\r\n    &.phone,\r\n    &.tel,\r\n    &.address {\r\n\r\n        // max-width: 400px;\r\n        &.hasValue:hover {\r\n            cursor: pointer;\r\n\r\n            p span.text {\r\n                // text-decoration: underline;\r\n                opacity: 0.8;\r\n            }\r\n        }\r\n\r\n        text-decoration: none;\r\n    }\r\n\r\n    &.email,\r\n    &.url,\r\n    &.link,\r\n    &.path,\r\n    &.phone,\r\n    &.tel {\r\n        &.hasValue:hover p span.text {\r\n            // text-decoration: underline;\r\n            color: var(--ion-color-medium);\r\n        }\r\n    }\r\n\r\n    ion-avatar {\r\n        display: inline;\r\n        border-radius: 100%;\r\n        text-align: center;\r\n        width: 20px;\r\n        height: 20px;\r\n        background: var(--ion-color-light-shade);\r\n        margin-right: 20px;\r\n        margin-top: -12px;\r\n\r\n        span {\r\n            font-size: 12px;\r\n            line-height: 20px;\r\n            top: 0;\r\n            color: var(--ion-color-secondary);\r\n        }\r\n    }\r\n\r\n    ion-thumbnail.r2023 {\r\n        margin-right: 20px;\r\n    }\r\n}\r\n\r\n.image-placeholder {\r\n    border: 1px solid var(--ion-color-lighter-contrast);\r\n    // background-color: var(--ion-color-lighter-light);\r\n    margin-top: 8px;\r\n    width: 100%;\r\n    text-align: center;\r\n\r\n    .icon-photo:before {\r\n        color: var(--ion-color-lighter-light);\r\n        content: \"\\e410\";\r\n        font-family: \"icomoon\" !important;\r\n        font-size: 80px;\r\n        line-height: 160px;\r\n    }\r\n}\r\n\r\nion-item.readonly .image-placeholder {\r\n    margin-top: 0px;\r\n}\r\n\r\napp-image-input {\r\n    width: 100%;\r\n}\r\n\r\napp-image-displayer {\r\n    margin-top: 8px;\r\n    border: 1px solid var(--mc-divider);\r\n}\r\n\r\n.signature-pad-edit,\r\n.signature-pad-view {\r\n    min-height: 200px;\r\n    position: relative;\r\n    margin: 8px auto;\r\n}\r\n\r\n.signature-pad-view {\r\n    border: 1px solid var(--mc-divider);\r\n}\r\n\r\n.signature-pad-clear {\r\n    &:before {\r\n        content: \"\\e5cd\";\r\n        color: var(--ion-color-lighter-light);\r\n        font-family: \"icomoon\" !important;\r\n        font-size: 18px;\r\n        line-height: 14px;\r\n        margin: 0 auto;\r\n        margin-left: -1px;\r\n    }\r\n\r\n    background: var(--mc-overlay-50);\r\n    text-align: center;\r\n    position: absolute;\r\n    right: 15px;\r\n    top: 50px;\r\n    padding: 8px;\r\n    border-radius: 50%;\r\n    width: 32px;\r\n    height: 32px;\r\n}\r\n\r\n.signature-pad-modify {\r\n    &:before {\r\n        content: \"\\e254\";\r\n        color: var(--ion-color-lighter-light);\r\n        font-family: \"icomoon\" !important;\r\n        font-size: 18px;\r\n        line-height: 14px;\r\n        margin: 0 auto;\r\n        margin-left: -1px;\r\n    }\r\n\r\n    background: var(--mc-overlay-50);\r\n    text-align: center;\r\n    position: absolute;\r\n    right: 10px;\r\n    top: 15px;\r\n    padding: 8px;\r\n    border-radius: 50%;\r\n    width: 32px;\r\n    height: 32px;\r\n}\r\n\r\n.vehicle ion-thumbnail img {\r\n    border-radius: 5px;\r\n}\r\n\r\n:host .datetime-calendar,\r\n:host .datetime-year {\r\n    border: 1px sold var(--ion-color-lighter-light);\r\n}\r\n\r\n.icon-padding {\r\n    padding-right: 5px;\r\n}\r\n\r\n.no-pointer {\r\n    cursor: default !important;\r\n}\r\n\r\n.view-button {\r\n    text-transform: none;\r\n    --border-radius: 5px;\r\n    --background: var(--mc-color-light-grey);\r\n    --color: var(--mc-color-dark-grey);\r\n    --color-activated: var(--ion-color-medium);\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    --box-shadow: none;\r\n    letter-spacing: 0;\r\n    margin-left: 0px;\r\n    height: 36px;\r\n}\r\n\r\n\r\napp-signature {\r\n    cursor: pointer;\r\n}\r\n\r\n.price-editor {\r\n    display: flex;\r\n    width: 100%;\r\n    flex-direction: row;\r\n    align-items: center;\r\n\r\n}\r\n\r\n.price-editor-button {\r\n    --color: var(--ion-color-secondary);\r\n    --background: transparent;\r\n    --border: none;\r\n    --box-shadow: none;\r\n    --hover-background: transparent;\r\n    --hover-border: none;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    padding-left: 5px;\r\n    padding-right: 0px !important;\r\n}\r\n\r\n.settings-icon {\r\n    padding-bottom: 2px;\r\n    font-size: 20px;\r\n}\r\n\r\n.non-editable-label {\r\n    color: var(--ion-color-medium);\r\n    cursor: pointer;\r\n    font-size: 12px;\r\n    align-self: center;\r\n}\r\n\r\n.rich-text-editor {\r\n    width: 100%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
